import * as accidentalDeathCoverActions from '../../../../actions/roaQuoteTools/lifeAndFuneralQuoteTool/accidentalDeathCoverQuoteTool/accidentalDeathCoverQuoteTool';
import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../../../status';

export const initialState = {
    selectedForm: 'form-one',
    formStatus: FORM_STATUS.INVALID,
    accidentalDeathCoverAmount: null,
    roaCmbObject: {
        __typename: 'Contentstack_call_me_back_ke',
        product: 'Accidental Death',
        privacy_policy_url: '/privacy-policy/',
        extra_fields:['Email Address'] 
    },
    form: {
        candidateDOB: { value: null, error: null, status: null },
        genderValue: { value: 'M', error: null, status: 'valid' },
        smokerCoveredValue: { value: 'No', error: null, status: 'valid' },
        coverAmount: { value: null, error: null, status: null },
        numberOfYearsCovered: { value: null, error: null, status: null },
        disabilityCoveredValue: { value: 'No', error: null, status: 'valid' },
    },
};

export default (state = initialState, action) => {
    const mapError = (error) =>
        error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID;
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case accidentalDeathCoverActions.FORM_VALID_ACCIDENTAL_DEATH_COVER_QUOTE_TOOL:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case accidentalDeathCoverActions.FORM_INVALID_ACCIDENTAL_DEATH_COVER_QUOTE_TOOL:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case accidentalDeathCoverActions.GENDER_SET_VALUE:
            return updateFormField('genderValue', (field) => ({
                ...field,
                value: action.value,
            }));

        case accidentalDeathCoverActions.CANDIDATE_DOB_SET_VALUE:
            return updateFormField('candidateDOB', (field) => ({
                ...field,
                value: action.value,
            }));

        case accidentalDeathCoverActions.CANDIDATE_DOB_SET_VALID:
            return updateFormField('candidateDOB', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case accidentalDeathCoverActions.SMOKER_COVERED_SET_VALUE:
            return updateFormField('smokerCoveredValue', (field) => ({
                ...field,
                value: action.value,
            }));

        case accidentalDeathCoverActions.COVER_AMOUNT_SET_VALUE:
            return updateFormField('coverAmount', (field) => ({
                ...field,
                value: action.value,
            }));

        case accidentalDeathCoverActions.COVER_AMOUNT_SET_VALID:
            return updateFormField('coverAmount', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case accidentalDeathCoverActions.YEARS_COVERED_SET_VALUE:
            return updateFormField('numberOfYearsCovered', (field) => ({
                ...field,
                value: action.value,
            }));

        case accidentalDeathCoverActions.YEARS_COVERED_SET_VALID:
            return updateFormField('numberOfYearsCovered', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case accidentalDeathCoverActions.DISABILITY_COVERED_SET_VALUE:
            return updateFormField('disabilityCoveredValue', (field) => ({
                ...field,
                value: action.value,
            }));

        case accidentalDeathCoverActions.WHICH_FORM_TO_DISPLAY:
            return {
                ...state,
                selectedForm: action.value,
            };

        //    API Call
        case accidentalDeathCoverActions.API_PENDING_TRANSITION_ACCIDENTAL_DEATH_COVER_QUOTE_TOOL:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };
        case accidentalDeathCoverActions.API_SUCCESS_TRANSITION_ACCIDENTAL_DEATH_COVER_QUOTE_TOOL:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };
        case accidentalDeathCoverActions.API_FAILURE_TRANSITION_ACCIDENTAL_DEATH_COVER_QUOTE_TOOL:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };

        //    Calculate the cover amount
        case accidentalDeathCoverActions.COLLECT_ACCIDENTAL_DEATH_COVER_PREMIUM_DATA:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case accidentalDeathCoverActions.CALCULATE_ACCIDENTAL_DEATH_COVER_SUCCESS:
            return { ...state, accidentalDeathCoverAmount: action.value };

        case accidentalDeathCoverActions.REINITIALIZE: {
            return initialState;
        }
        default: {
            return state
        }
    }
};
